import { createAction } from '@reduxjs/toolkit';

export const fetchImage = createAction<string>(
  '@@modals/linkToImage/fetchImage',
);
